import { useContext } from 'react'
import { ApplicationContext } from '../../App'
import PayerEligibilityTransactionsTable from '../../components/PayerEligibilityTransactionsTable'
import ProviderEligibilityTransactionsTable from '../../components/ProviderEligibilityTransactionsTable'
import BaseView from '../BaseView'
const Transactions = () => {
    const identities = useContext(ApplicationContext)?.identities ?? []
    const ownOrg = identities.find((entry: any) => entry.self)
    return (
        <BaseView
            title="Eligibility Transactions"
            tabNames={['SUCCESS', 'FAILED']}
            subviews={
                ownOrg?.type === 'payer'
                    ? [
                          <PayerEligibilityTransactionsTable status="SUCCESS" key={0} />,
                          <PayerEligibilityTransactionsTable status="ERROR" key={1} />,
                      ]
                    : [
                          <ProviderEligibilityTransactionsTable status="SUCCESS" key={0} />,
                          <ProviderEligibilityTransactionsTable status="ERROR" key={1} />,
                      ]
            }
        />
    )
}

export default Transactions
